__turbopack_context__.v({
  "selected": "Tab-module-scss-module__jyEY3G__selected",
  "tab": "Tab-module-scss-module__jyEY3G__tab",
  "unselected": "Tab-module-scss-module__jyEY3G__unselected",
});
